import React from 'react';

export const ingredients = [
    {
        name: "Whole Veggies",
        image: "https://cdn.shopify.com/s/files/1/0550/9614/8034/files/g-veggie-1.svg?v=1730946282https://cdn.shopify.com/s/files/1/0550/9614/8034/files/g-veggie.svg?v=1703012396",
        description: "Rich in nutrients and contains fiber"
    },
    {
        name: "Whole Fruits",
        image: "https://cdn.shopify.com/s/files/1/0550/9614/8034/files/g-fruit_a3f41f64-d9cf-485b-8a5c-443a058dede6.svg?v=1730946282",
        description: "Natural sweetness packed with vitamins"
    },
    {
        name: "Vitamins and Minerals",
        image: "https://cdn.shopify.com/s/files/1/0550/9614/8034/files/g-vitamins_fe7cdafc-e7ba-4d1e-a556-27c5649dc0b3.svg?v=1730946282",
        description: "Essential nutrients for daily health"
    },
    {
        name: "Adaptogens",
        image: "https://cdn.shopify.com/s/files/1/0550/9614/8034/files/g-adaptogens-1.svg?v=1730946282",
        description: "Helps body adapt to stress"
    },
    {
        name: "Herbs",
        image: "https://cdn.shopify.com/s/files/1/0550/9614/8034/files/g-herbs-1.svg?v=1730946282",
        description: "Natural botanical benefits"
    },
    {
        name: "Antioxidants",
        image: "https://cdn.shopify.com/s/files/1/0550/9614/8034/files/g-veggie-1.svg?v=1730946282",
        description: "Protects cells from damage"
    },
    {
        name: "Prebiotics",
        image: "https://cdn.shopify.com/s/files/1/0550/9614/8034/files/g-prebiotics-1.svg?v=1730946282",
        description: "Supports gut health"
    },
    {
        name: "Super Mushrooms",
        image: "https://cdn.shopify.com/s/files/1/0550/9614/8034/files/g-mushrooms_f747035f-f44f-4b84-ab65-b78139ffca26.svg?v=1730946282",
        description: "Powerful immune support"
    }
];
   

export const accordionItems = [
    {
        title: 'Does this show up on a drug test ?',
        content: (
            <div className="space-y-4 text-[13px] text-black">
                <p className="font-medium">It should not show up on a urine or breathalyzer, but please do not drive if impaired, you can still get a DUI, just like if you took THC.As for blood test, we had one report of a false positive.Consider asking / telling your employer that you would like to use this drink.</p>

            </div>
        )
    },
    {
        title: 'TASTE.Why do some people love and others HATE the taste ?',
        content: (
                    <p className="mb-3">
                        We cover this on HardKetones.com / taste blog post.
                    </p>
        )
    },
    {
        title: 'BUZZ.What type of buzz is this ? Is it real ?',
        content: (
            <p className="mb-3">
                We find that 80 % feel a buzz with 2. They describe it as a cross between a beer and THC, but without the sleepiness and food cravings.It may be best to start with 2 or 3 the first time to make sure you feel it.The other 20 % seem to be because they use SSRIs, SNRIs or Kratom(doesn't work). Also some that have a super high alcohol tolerance, may not feel the buzz but should still feel the reduced desire to drink and help with withdrawal symptoms. Also those that hate the taste and are pissed off, that likely isn't a relaxing state to feel it.See taste adjustments above.Feel the Buzz, or it is Free. 100 % Money Back Guarantee in the USA(except the Dr.Up, we don't refund that based on taste). 
            </p>
        )
    },
    {
        title: 'PRICE.Why is it so damn expensive ?',
        content: (
                    <p className="mb-3">
                        It may seem that way at first, but the value is there for most people once they understand it.Don't think of it as a 1 can vs 1 can comparison. Also we did also just increase the Ketohol by 40% with no price increase. We will have a blog post on this soon, you can see this video in the meantime that should cover it here.
                    </p>

        )
    }
];

export const autoShipPlans = {
    plans: [
        {
            name: "One Person",
            price: "40.79",
            originalPrice: "79.99",
            perDay: "1.46",
            discount: "49",
            style: "bg-[#E6F0EB]"
        },
        {
            name: "Two People",
            price: "77.52",
            originalPrice: "159.98",
            perDay: "1.38",
            discount: "52",
            style: ""
        }
    ],
    benefits: [
        "28 packs every 4 weeks (224 gummies)",
        "FREE avg 2-day shipping today",
        "Pause or cancel anytime",
        "30-day money back guarantee"
    ]
};

export const productImages = [
    "https://cdn.shopify.com/s/files/1/0022/3821/8300/files/SuperBasic-GirlTalk-16.jpg?v=1732429923",
    "https://cdn.shopify.com/s/files/1/0022/3821/8300/files/HK3x12ozTrialPack.jpg?v=1732471590",
    "https://cdn.shopify.com/s/files/1/0022/3821/8300/files/SuperBasic-GirlTalk-06.jpg?v=1732429922",
    "https://cdn.shopify.com/s/files/1/0022/3821/8300/files/SuperBasic-GirlTalk-11.jpg?v=1732429922",
    "https://cdn.shopify.com/s/files/1/0022/3821/8300/files/SuperBasic-GirlTalk-12.jpg?v=1732429922",
    "https://cdn.shopify.com/s/files/1/0550/9614/8034/files/Lifestyle_03_-_Adults.png?v=1730946189&width=1800"
]; 